var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProfileSubsectionTitle',{attrs:{"subsection_title":"Certification"}}),_vm._l((_vm.certifications),function(certification){return _c('CertificationItem',{key:certification.id,attrs:{"certification":certification}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }